export default __webpack_public_path__ + "assets/logo-corner.b52e9dba3b48054755aaeb400be82b6c.svg";